import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TimelineEvent = ({ event, isLast }) => {
  const getEventIcon = (type) => {
    const icons = {
      'volunteer': 'Heart',
      'certificate': 'Award',
      'milestone': 'Trophy',
      'skill': 'Zap',
      'connection': 'Users'
    };
    return icons?.[type] || 'Circle';
  };

  const getEventColor = (type) => {
    const colors = {
      'volunteer': 'bg-primary',
      'certificate': 'bg-accent',
      'milestone': 'bg-success',
      'skill': 'bg-secondary',
      'connection': 'bg-primary'
    };
    return colors?.[type] || 'bg-muted';
  };

  return (
    <div className="relative flex gap-4 pb-8">
      <div className="flex flex-col items-center">
        <div className={`w-10 h-10 rounded-full ${getEventColor(event?.type)} flex items-center justify-center z-10`}>
          <Icon name={getEventIcon(event?.type)} size={20} color="white" />
        </div>
        {!isLast && (
          <div className="w-0.5 h-full bg-border mt-2" />
        )}
      </div>
      <div className="flex-1 pt-1">
        <div className="bg-card rounded-lg p-4 border border-border hover:shadow-md transition-all">
          <div className="flex items-start justify-between mb-2">
            <div className="flex-1">
              <h4 className="font-semibold text-foreground mb-1">{event?.title}</h4>
              <p className="text-sm text-muted-foreground">{event?.description}</p>
            </div>
            <span className="text-xs text-muted-foreground whitespace-nowrap ml-4">{event?.date}</span>
          </div>
          {event?.organization && (
            <div className="flex items-center gap-2 mt-3">
              <Image 
                src={event?.organizationLogo}
                alt={event?.organizationLogoAlt}
                className="w-6 h-6 rounded object-cover"
              />
              <span className="text-sm text-muted-foreground">{event?.organization}</span>
            </div>
          )}
          {event?.impact && (
            <div className="mt-3 pt-3 border-t border-border">
              <div className="flex items-center gap-2 text-sm">
                <Icon name="TrendingUp" size={16} className="text-success" />
                <span className="text-muted-foreground">{event?.impact}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TimelineEvent;